import getEnv from '@/utils/env';
import router from '../router/index';
import store from '../store/index'
import AuthService from "../services/AuthService";
import {appInstance} from "@/main";
import {getCurrentInstance} from "vue";


export default {

    parse({error, redirectTo404Page, redirectTo500Page, redirectToLoginPage, clearAuthData, showNotification}) {

        if (error.response) {
            const status = error.response.status;
            let message = error.response.message ? error.response.message : error.response.data;
            if(message.errors) {
                message = message.errors.map(x=> {return x.message;}).join(' | ');
            }
            const response = error.response;

            switch (status) {
                case 401: {
                    if (clearAuthData) {
                        AuthService.clearAuthData();
                    }

                    if (redirectToLoginPage) {
                        window.location.replace(`${getEnv('VUE_APP_QSC_ADMIN_UI_LOGIN_URI')}`);
                    }

                    return new Error('Request not authorized');
                }
                case 403: {
                    if (clearAuthData) {
                        AuthService.clearAuthData();
                    }
                    if (showNotification) {
                        appInstance.config.globalProperties.$snotify.error('request faild  403 Error')
                    }
                    if (redirectToLoginPage) {

                        window.location.replace(`${getEnv('VUE_APP_QSC_ADMIN_UI_LOGIN_URI')}`);
                    }

                    return new Error('Request not authorized');
                }
                case 400: {
                    if (response.data.timestamp && response.data.requestId) {
                       // store.dispatch('SET_ERROR_DATA', response.data);
                    }
                    if (showNotification) {

                        appInstance.config.globalProperties.$snotify.error('Request failed. Bad request')

                    }

                    return new Error('Request failed. Request endpoint not found on the server');
                }
                case 404: {
                    if (showNotification) {
                        appInstance.config.globalProperties.$snotify.error('Request failed. Request endpoint not found on the server')

                     }

                    if (redirectTo404Page) {
                        router.push({name: 'Error-404'});
                    }

                    return new Error('Request failed. Request endpoint not found on the server');
                }
                case 409: {
                    if (response.data.timestamp && response.data.requestId) {
                       // store.dispatch('SET_ERROR_DATA', response.data);
                    }
                    if (showNotification) {
                        appInstance.config.globalProperties.$snotify.error('Request Error 409 '+JSON.stringify(message))

                    }
                    return new Error('This is rephrased error message. Please try again later');
                }
                case 500: {
                    if (redirectTo500Page) {
                        router.push({name: 'Error-500'});
                    }
                    if (showNotification) {
                        appInstance.config.globalProperties.$snotify.error('This is rephrased error message. Please try again later ')

                    }

                    return new Error('This is rephrased error message. Please try again later');
                }
                case  405: {
                    if(showNotification) {
                        appInstance.config.globalProperties.$snotify.error('request failed with status code 405')

                    }
                    return new Error('This is rephrased error message. Please try again later');

                }
                default: {
                    if (showNotification) {
                        appInstance.config.globalProperties.$snotify.error('This is rephrased error message. Please try again later ')

                    }

                    return new Error(message);
                }

            }

        }
    }
}
